import { DotPhraseTemplate } from '../../types/dotPhrase'
import { adminCollectionAccess } from '../constants'
import { DOT_PHRASE_TEMPLATES } from '../names'
import { FirestoreCollection } from '../types'

export const dotPhraseTemplatesCollection: FirestoreCollection<DotPhraseTemplate> = {
  id: 'dotPhraseTemplates',
  _type: 'firestoreCollection',
  name: 'Dot Phrase Templates',
  refPath: DOT_PHRASE_TEMPLATES,
  access: adminCollectionAccess,
  defaultSort: 'keyword',
}
